import vm from '../main'

const internals = {}

internals.addsalesdata = function(salesdata) {
    salesdata = (({
        region,
        site,
        totalValue,
        dispenserData,
        reportedDate,
        _id
    }) => {
        return {
            region,
            site,
            totalValue,
            dispenserData,
            reportedDate,
            _id
        }
    })(salesdata)

    return vm.$salesdataDataRepository
        .create(salesdata)
        .then(result => {
            salesdata = result.data
            return salesdata
        })
        .catch(error => {
            console.error('salesdataService.createsalesdata-error:\n', error)
            throw error
        })
}

internals.updatesalesdata = function(salesdata) {
    salesdata = Object.assign({}, salesdata)

    salesdata = (({
        region,
        site,
        totalValue,
        dispenserData,
        reportedDate,
        _id
    }) => {
        return {
            region,
            site,
            totalValue,
            dispenserData,
            reportedDate,
            _id
        }
    })(salesdata)

    return vm.$salesdataDataRepository
        .update(salesdata._id, salesdata)
        .then(result => {
            salesdata = result.data
            return salesdata
        })
        .catch(error => {
            console.error('salesdataUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/salesdata.service.js